import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import { blazeRetailLogo } from '../assets'

class SideCover extends Component {
  render() {
    const { WrappedComponent = null, heading = 'BLAZE Login', ...restProps } = this.props

    return (
      <Grid container>
        <Grid
          className="auth-bg"
          item
          lg={6}
          md={6}
          sm={12}
          xs={12}
          style={{
            backgroundSize: 'cover',
              backgroundColor: '#29333B',
          }}
        >
          <div
            className="full-height full-width"
          >
            <Grid container className="center-aligned-child full-height">
              <Grid className="leftBlockLogin" item xs={11} sm={12} md={12} lg={12}>
                  <Grid style={{ display: "flex", justifyContent: "space-evenly"}}>
                      <img
                          src={blazeRetailLogo}
                          height={100}
                          width={100}
                          title={"Blaze Retail"}
                      />
                  </Grid>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <Grid container className="center-aligned-child full-height">
            <WrappedComponent {...restProps} />
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

const SideCoverHOC = (WrappedComponent) => (props) =>
  <SideCover WrappedComponent={WrappedComponent} {...props} />

export default SideCoverHOC



// WEBPACK FOOTER //
// ./src/containers/SideCover.js